import { QRFC } from "./QRFC";

export class QFileRFC extends QRFC {
  constructor() {
    super();
    this.fOrgName = null;
    this.fPath = null;
    this.fMode = null;
    this.fEntityType = null;
    this.fFileName = null;
    this.resolvePromise = null;
    this.rejectPromise = null;
  }

  InitFileRFC(callbackObj, entityType, dirStart, file, resolve, reject) {
    this.fEntityType = entityType;
    this.fDirectory = dirStart;
    this.fFileName = file;
    this.resolvePromise = resolve;
    this.rejectPromise = reject;
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qfileJSON";
  }

  SetParams(org, user, mode, data) {
    this.fData = data;
    this.fMode = mode;
    this.fOrgName = org;
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mode", mode);
    this.AddEncodedParameter("data", JSON.stringify(data));
  }

  DoTransactionComplete(response, callBackObj) {
    try {
      const parsedResponse = JSON.parse(response);
      if (callBackObj && typeof callBackObj.FileResult === "function") {
        callBackObj.FileResult(
          parsedResponse,
          this.fMode,
          this.fEntityType,
          this.fDirectory,
          this.fFileName,
          this.fData
        );
      }

      if (this.resolvePromise) {
        this.resolvePromise({
          response: parsedResponse,
          mode: this.fMode,
          entityType: this.fEntityType,
          directory: this.fDirectory,
          fileName: this.fFileName,
          data: this.fData
        });
      }
    } catch (error) {
      if (this.rejectPromise) {
        this.rejectPromise(error);
      }
    }
  }

  DoTransactionFailed(error) {
    if (this.rejectPromise) {
      this.rejectPromise(error || new Error("File transaction failed"));
    }
  }
}
